export default "/fonts/vendor/mdui/dist/roboto/Roboto-Medium.woff2?b92cc2170a4d5438fd3d19f349ce3785";